<template>
  <header v-if="!isNewHeaderShow">
    <div v-if="NewHomePage" id="main-menu" class="main-menu-container1">
      <div class="main-menu">
        <div class="container">
          <div class="navbar-default">
            <div class="navbar-header float-left">
              <a class="navbar-brand text-uppercase" href="/index" style="padding: 0;"><img :src="logo2Src" alt="logo"></a>
            </div>

            <k-login></k-login>

            <nav class="navbar-menu float-right">
              <div class="nav-menu ul-li">
                <ul>
                  <li>
                    <router-link :to="{ name: 'index'}">主页</router-link>
                  </li>
                  <li>
                    <router-link :to="{ path: '/store' }">培训报名</router-link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div v-else id="main-menu" class="main-menu-container">
      <div class="main-menu">
        <div class="container">
          <div class="navbar-default">
            <div class="navbar-header float-left">
              <a class="navbar-brand text-uppercase" href="/index"><img :src="logoSrc" alt="logo"></a>
            </div>
            <div v-if="projectName == 'XYSJZY'" style="display: flex; align-items: center; color: #FFF; height: 64px;" class="navbar-header float-left">
              <div style="margin:0 10px 0 20px"><img src="https://xysjzy-1253588055.cos.ap-shanghai.myqcloud.com/phone.png" alt="logo"></div>
              <div>
                <div style="font-size:24px">0790-6456096</div>
                <div style="font-size:14px">培训考试咨询电话</div>
              </div>
            </div>

            <k-login></k-login>

            <!-- Collect the nav links, forms, and other content for toggling -->
            <nav class="navbar-menu float-right">
              <div class="nav-menu ul-li">
                <ul>
                  <li>
                    <router-link :to="{ name: 'index'}">主页</router-link>
                  </li>
                  <li>
                    <router-link v-if="projectName != 'XYSJZY'" :to="{ path: '/store' }">培训报名</router-link>
                  </li>
                  <li>
                    <router-link :to="{ path: '/diploma' }">证书查询</router-link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
  <header v-else class="header_gradient">
    <div class="container">
      <div class="navbar-default">
        <div class="navbar-header">
          <a class="navbar-brand text-uppercase" href="#"><img style="max-height: 64px;" :src="logoSrc" alt="logo"></a>
        </div>
        <div class="header-info ul-li">
          <ul>
            <li>
              <div class="mail-phone">
                <div class="info-icon">
                  <i class="text-gradiant fas fa-phone-square"></i>
                </div>
                <div class="info-content">
                  <span class="info-id">{{telephone}}</span>
                  <span class="info-text">培训报名、业务咨询电话</span>
                </div>
              </div>
            </li>
            <li>
              <el-popover placement="bottom" width="390" trigger="hover">
                <div class="nav-menu-wechat">
                  <div style="display: flex;">
                    <div>
                      <img :src="QQURL" alt="">
                      <div>监理 QQ 群：338579713</div>
                    </div>
                    <div>
                      <img src="https://jxjzcj-1253588055.cos.ap-shanghai.myqcloud.com/assets/%E6%A3%80%E6%B5%8B%E5%91%98%20QQ%20%E7%BE%A4%E4%BA%8C%E7%BB%B4%E7%A0%81-20250630170650.jpg" alt="">
                      <div>检测 QQ 群：297214271</div>
                    </div>
                  </div>
                  <!-- <div>扫一扫二维码，加入群聊</div> -->
                </div>
                <a href="#" slot="reference">
                  <div class="info-social">
                    <i class="fab fa-qq"></i>
                  </div>
                  <span class="info-text">QQ&nbsp;群</span>
                </a>
              </el-popover>
            </li>
            <li>
              <el-popover placement="bottom" width="200" trigger="hover">
                <div>
                  <img style="width:180px;" :src="WeiXinAppURL" alt="">
                  <div style="font-size:14px; text-align:center;margin-top:4px;">微信扫一扫，使用小程序</div>
                </div>
                <a href="#" slot="reference">
                  <div class="info-social" style="height:36px; padding-top: 5px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" viewBox="0 0 20.211 32" fill="#FFFFFF">
                      <path id="mobile-alt" class="cls-1" d="M17.179,0H3.032A3.017,3.017,0,0,0,0,3V29a3.017,3.017,0,0,0,3.032,3H17.179a3.017,3.017,0,0,0,3.032-3V3A3.017,3.017,0,0,0,17.179,0ZM10.105,30a2,2,0,1,1,2.021-2A2.008,2.008,0,0,1,10.105,30Zm7.074-6.75a.756.756,0,0,1-.758.75H3.789a.756.756,0,0,1-.758-.75V3.75A.756.756,0,0,1,3.789,3H16.421a.756.756,0,0,1,.758.75Z" />
                    </svg>
                  </div>
                  <span class="info-text">手机学习</span>
                </a>
              </el-popover>
            </li>
          </ul>
        </div>

        <div class="nav-menu-4">
          <div class="login-cart-lang float-right ul-li">
          </div>
          <!-- Collect the nav links, forms, and other content for toggling -->
          <nav class="navbar-menu">
            <div class="nav-menu ul-li">
              <ul>
                <li>
                  <router-link :to="{ name: 'index'}">首页</router-link>
                </li>
                <li><a href="javascript:void(0)" @click="toIndexSection('course-page')">培训报名</a></li>
                <li><a href="javascript:void(0)" @click="toIndexSection('news-section')">通知公告</a></li>
                <li><a href="javascript:void(0)" @click="toIndexSection('news-section')">测试安排</a></li>
                <li><a href="javascript:void(0)" @click="toIndexSection('news-section')">中心动态</a></li>
                <li v-show="projectName == 'NCJZJY'">
                  <router-link :to="{ name: 'xqhz'}">校企合作</router-link>
                </li>
                <li><a href="javascript:void(0)" @click="toIndexSection('news-section')">证书查询</a></li>
                <li><a href="javascript:void(0)" @click="toIndexSection('contact-section')">联系我们</a></li>
                <!-- <li><a href="javascript:void(0)" @click="toIndexSection('about-section')">关于我们</a></li> -->
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import Cookies from 'js-cookie'
import { ProjectSettings } from '@/views/base/base.js'

export default {
  name: 'k-header',
  props: {
    isNewHeaderShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      projectName: ProjectSettings.Name,
      telephone: ProjectSettings.Telephone,
      logoSrc: ProjectSettings.LogoURL,
      logo2Src: ProjectSettings.Logo2URL,
      NewHomePage: ProjectSettings.NewHomePage,
      displayName: null,
      JfQRCodeURL: ProjectSettings.JfQRCodeURL,
      QQURL: ProjectSettings.QQURL,
      WeiXinAppURL: ProjectSettings.WeiXinAppURL
    }
  },
  mounted() {
    this.displayName = Cookies.get('DisplayName');
    // if (this.displayName) {
    //   this.isNewHeaderShow = false;
    // }
  },
  methods: {
    onIndex() {
      this.$router.push({ name: 'index' });
    },
    onSupermarket() {
      this.$router.push({ name: 'supermakrket' });
    },
    toIndexSection(id) {
      console.log('path', this.$route.path);
      if (this.$route.path !== '/index') {
        this.$router.push({ name: 'index', query: { toSection: id } });
      } else {
        $('html,body').animate({ scrollTop: $('#' + id).offset().top }, 1000);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header_gradient {
  padding: 24px 0px 69px 0;
  position: relative;
  background-image: linear-gradient(
    to right,
    rgb(1, 166, 253) 0%,
    rgb(23, 208, 207) 51%,
    rgb(1, 166, 253) 100%
  );
  -webkit-transition: 0.3s all ease-in-out;
  -o-transition: 0.3s all ease-in-out;
  transition: 0.3s all ease-in-out;
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
  .navbar-default {
    display: flex;
    justify-content: space-between;
    margin-right: 20px;
    align-items: center;
    .header-info li {
      margin-left: 35px;
    }
    .nav-menu-4 {
      z-index: 2;
      .nav-menu {
        ul {
          margin: 0 10px;
          display: flex;
          justify-content: space-between;
        }
        li {
          a {
            font-size: 15px;
            font-weight: bold;
            -webkit-transition: 0.3s all ease-in-out;
            -o-transition: 0.3s all ease-in-out;
            transition: 0.3s all ease-in-out;
          }
          a:after {
            color: #00eab2;
            background-size: 0;
          }
          a:hover {
            color: #00eab2;
            background-color: #fff;
          }
        }
      }
    }
  }
}
.header_gradient.full-width-menu {
  position: fixed;
  width: 100%;
  -webkit-transition: 0.3s all ease-in-out;
  -o-transition: 0.3s all ease-in-out;
  transition: 0.3s all ease-in-out;
  margin-top: -100px;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/views/home/header.vue